import { isEmpty } from "lodash-es";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { IEditableSectionRenderProps } from "@/components/EditableSection";
import { Header } from "@/components/Header";
import { Text } from "@/components/Text";
import { Flex, FloatedList, Section } from "@/eworkitComponents";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { IConsultantProfileSectionProps } from "@/views/components/ConsultantProfile/Sections/types";
import { SkillLevel } from "@/views/components/Skills";
import { ConsultantProfileRoleEdit } from "@/views/ConsultantProfiles/Detail/RoleSection/RoleForm";

interface RoleSectionProps extends IConsultantProfileSectionProps, IEditableSectionRenderProps {}

export const RoleSection: FunctionComponent<RoleSectionProps> = ({ editableProps, onUpdate, record }) => {
  const { t } = useTranslation("session");
  const isRoleListEmpty = isEmpty(record.roles);
  const tCodelist = useCodelistTranslation();

  return (
    <Section grow={1} direction="column" innerMargin="md" testName="role">
      <Flex
        direction="row"
        justify="space-between"
        margin={[false, "lg", false, false]}
        padding={[false, "md", false, false]}
        innerMargin="md">
        <Header size="sm" color="black" weight="bold">
          {t("CONSULTANT_PROFILES.DETAIL.ROLE.SECTION_HEADER")}
        </Header>
      </Flex>
      <Flex grow={1} innerMargin="sm">
        {editableProps.editMode ? (
          <ConsultantProfileRoleEdit
            source={record}
            initialValues={{ roles: record.roles }}
            onUpdate={onUpdate}
            onCancel={editableProps.handleCancelClick}
            editableProps={editableProps}
          />
        ) : isRoleListEmpty ? (
          <Text size="md" color="grey3">
            {t("CONSULTANT_PROFILES.DETAIL.ROLE.NO_ROLE")}
          </Text>
        ) : (
          <FloatedList size="sm">
            {record.roles.map(value => (
              <SkillLevel
                key={`badge-level-${value.role}`}
                color="secondary"
                round
                mono={false}
                size="md"
                text={value.role.name}
                levelText={value.roleLevel ? tCodelist("skill-role-levels", value.roleLevel) : undefined}
                testName={`roles[${value.role}]`}
              />
            ))}
          </FloatedList>
        )}
      </Flex>
    </Section>
  );
};
